import styled from 'styled-components';
import Image from '../../common/Image/Image';
import RupeeIcon from '../../../../Icons/RupeeIcon';
import {SmallSectionHeader} from '../../../CommonStyleUtils/dwebCommon.styles';

export const SuggestedMainWrapper = styled.section(
  props => `
    margin-top: ${props.theme.spacing.xxlarge};
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    position:relative;
  `,
);

export const SuggestedHeaderNavOuter = styled.ul(
  props => `
    width: 100;
    list-style-type: none;
    display: flex;
    padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.large} 0 ${
    props.theme.spacing.large
  };
    border-bottom: ${props.theme.spacing.custom(2)} solid ${props.theme.colors.ash.medium};
    li{
        width: 20%;
        text-align: center;
        padding-bottom: ${props.theme.spacing.base};
        border-bottom: 0.3rem solid transparent;
        font-size: ${props.theme.font.custom(16)};
        font-family: ${props.theme.font.fontFamily};
        cursor: pointer;
        &.active{
            border-bottom: 0.3rem solid ${props.theme.colors.goBrandBlue.base};
            font-weight: bold;
        }
      }
    `,
);

export const SuggestedCardList = styled.ul`
  width: 100%;
  display: flex;
  list-style-type: none;
  padding: ${props => props.theme.spacing.base} ${props => props.theme.spacing.large};
  position: relative;
`;

export const SuggestCardListLi = styled.li`
  width: 28rem;
  height: ${props => (props.hasContent ? '24rem' : '20rem')};
  padding: ${props => props.theme.spacing.base};
  display: flex;
  margin-right: ${props => props.theme.spacing.base};
  cursor: pointer;
`;

export const SuggestCardImage = styled(Image)(
  props => `
    width:100%;
    height: 14.5rem;
    display: flex;
    margin-bottom: ${props.theme.spacing.base};
    object-fit: cover;
  `,
);

export const SuggestedMainText = styled(SmallSectionHeader)(
  props => `
    padding-bottom: ${props.theme.spacing.xsmall};
  `,
);

export const SuggestedTotalText = styled.span(
  props => `
      font-size: ${props.theme.font.custom(14)};
      color: ${props.theme.colors.downriver.dark};
      padding-bottom: ${props.theme.spacing.xsmall};
  `,
);

export const SuggestedPriceWrap = styled.div(
  props => `
        display: flex;
        align-items: center;
        margin-bottom: 0.5rem;
    `,
);

export const RuppeIconSuggest = styled(RupeeIcon)(
  props => `
        width: 1.2rem;
        height: 1.2rem;
        fill: ${props.theme.colors.downriver.base};
    `,
);

export const SuggestedPriceText = styled.p(
  props => `
        font-size: ${props.theme.font.custom(16)};      
        font-family: ${props.theme.font.fontFamily};
        font-weight: bold;
        padding-right: ${props.theme.spacing.small};
    `,
);

export const SuggestedPaxText = styled.span(
  props => `
        font-size: ${props.theme.font.custom(14)};
        color: ${props.theme.colors.downriver.medium};
    `,
);

export const SliderArrowRight = styled.button(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -1rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);

export const SliderArrowLeft = styled.button(
  props => `
    width: 4rem;
    height: 4rem;
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.goWhite.base};
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -1rem;
    transform: translateY(-50%);
    box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
    border:none;
    &:focus{
      outline: none;
    }
  `,
);
